import {
  CalidadProducto,
  DetalleCombustible,
  DetalleCisterna,
} from "@shared/models/stock";

export class DetalleProducto {
  id: string;
  cantidad: number;
  codigoProducto: string;
  nombreProducto: string;
  tipoProducto: number;
  calidadProducto: CalidadProducto;
  detalleCombustible: DetalleCombustible;
  detalleCisternas: DetalleCisterna[];
  recibeProducto: boolean;
}
